/* unplugin-vue-components disabled */import { render } from "./tracker.vue?vue&type=template&id=408231a1"
import script from "./tracker.vue?vue&type=script&lang=js"
export * from "./tracker.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/tracker/tracker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "408231a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('408231a1', __exports__)) {
    api.reload('408231a1', __exports__)
  }
  
  module.hot.accept("./tracker.vue?vue&type=template&id=408231a1", () => {
    api.rerender('408231a1', render)
  })

}


export default __exports__